import {
  PairedSalesAnalysisFeature,
  StudiesPair,
  ToolkitStudyV1Request,
} from '@aloft/toolkit-shared';
import { StyleSheet, View } from '@react-pdf/renderer';

import { Text } from '../../../components/pdf-export/Text/Text.js';
import { generateAdjustResultsSummaryStatistics } from '../../adjustPairedSalesStandalone/utils/generateAdjustResultSummaryStatistics.js';
import { makeAdjustResult } from '../utils/makeAdjustResult.js';

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    gap: 16,
  },
});

type Props = {
  pairs: StudiesPair[];
  reconciledValue: ToolkitStudyV1Request['body']['reconciledValue'];
  feature: PairedSalesAnalysisFeature;
};

export function ReconciliationStats({ pairs, reconciledValue, feature }: Props) {
  if (pairs.length <= 1) return null;

  const adjustResults = pairs.map((pair) => makeAdjustResult(pair, reconciledValue, feature));
  const { median, average } = generateAdjustResultsSummaryStatistics(adjustResults);

  return (
    <View style={styles.wrapper}>
      <Text variant="subtitle3">{`Median: ${
        median.t === 'absolute' ? median.value.toString(true) : median.value
      }`}</Text>
      <Text variant="subtitle3">
        {`Average: ${average.t === 'absolute' ? average.value.toString(true) : average.value}`}
      </Text>
    </View>
  );
}
